import styled from 'styled-components';

import {
  colorBlack300,
  colorBlack900,
  colorBorder,
  colorWhite,
  mediaQueryLaptopMin,
} from '@/styleUtils';

import {
  StaticContentSection,
  StaticContentText,
  StaticContentTitle,
} from '../StaticContent.styles';

export const StyledStaticContentSection = styled(StaticContentSection)`
  gap: 16px;
`;
export const StiledSubtitle = styled(StaticContentTitle)`
  font-size: 16px;
  line-height: 24px;
  background-color: ${colorWhite};
  text-align: left;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${colorBlack900};
  svg {
    height: 14px;
    color: ${colorBlack300};
  }
`;

export const StyledText = styled(StaticContentText)`
  display: ${({ $show }) => ($show ? 'block' : 'none')};
  transition: height 0.3s ease-out;

  ul {
    margin: 8px;
    padding-left: 22px;
  }

  div > p {
    margin-bottom: 8px;
  }
`;
export const QuestionItem = styled.div`
  display: flex;
  border: 1px solid ${colorBorder};
  border-radius: 16px;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  color: ${colorBlack900};
  &:last-child {
    box-shadow: none;
  }
  @media ${mediaQueryLaptopMin} {
    padding: 24px;
  }
`;
